/*global site*/
import {device} from './Helpers/UserDevice';
import {$ ,scrollToPos} from './Helpers/utils';

site = jQuery.extend(site, {});

(function() {



    site.showsGrid = function() {
        if(!$('.showGrid').length) {
            return;
        }

            var gridLayout = $('.showGrid').data('layout');
        var allowFilter = $('.site-header-main').length;



        if(allowFilter){
            //filter the grid:
            site.gridFilter = [];
            $(document).on('click', '#menu-hp_cat_menu a', function(e) {
                e.preventDefault();
                var li = $(this).parent();
                var filterValue = li.data('filter');
                var i = site.gridFilter.indexOf(filterValue);
                console.log(filterValue);
                $('#menu-hp_cat_menu li').removeClass('current-menu-item');
                li.addClass('current-menu-item');

                if(li.hasClass('showall')) {
                    site.gridFilter = [];
                    $('.showGrid article').show();
                    return;
                }

                $('.showGrid article').hide();
                $('.showGrid article' + filterValue).show();

            });

        }

        $('.moreDetails').focus(function(e){
            var item = $(this).parents('.item-show')
            item.addClass('hover')
        })
        $('.moreDetails').blur(function(e){
            var item = $(this).parents('.item-show')
            item.removeClass('hover')
        })
        $('.item-show').keydown(function(e){
            if(e.keyCode===13){
                $(e.target).find('.item_link').click()
            }
        })

    };


    site.getFormData = function($form) {
        var unindexed_array = $form.serializeArray();
        var indexed_array = {};

        $.map(unindexed_array, function(n, i) {
            indexed_array[n['name']] = n['value'];
        });

        return indexed_array;
    }

    device.mobileileFix=function(){
        if(device.mobile){
            $('.remove-from-mobile').remove();
        }
        else{
            $('.remove-from-desktop').remove();
        }
    };

    site.polyfills = function() {

        //startsWith
        if(!String.prototype.startsWith) {
            String.prototype.startsWith = function(searchString, position) {
                position = position || 0;
                return this.substr(position, searchString.length) === searchString;
            };
        }

    };

    site.print_info_btn= function() {
        var btn = $('#print_info_btn')
        var content = $('#print_info_details')

        btn.on('click',function(e){
            e.preventDefault();
            var contentHtml = '<div class="inner"><div class="popText" tabindex="0" role="document">';
            contentHtml += content.html();
            contentHtml += '</div></div>';
            jQuery.fancybox({
                type      : 'html',
                content   : contentHtml,
                scrolling : 'auto',
                topRatio  : 0,
                padding   : 0,
                margin    : [42, 10, 10, 10],
                beforeShow: function() { },
                afterShow: function() {
                    $('.fancybox-wrap').attr('role','dialog')
                    $('.fancybox-close').focus()
                    $('.fancybox-close').attr('href','#')
                    $('.fancybox-close').keydown(function(e){
                        var keyCode = e.keyCode || e.which;
                        if (keyCode === 9) {
                            $('.popText').focus()
                        }
                    });

                }
            });
        })

    }

      site.initContentPanels = function() {

        var panels =  $('.tab-content');
        var btns   =  $('.tab-btn');

        if(device.mobile){
            btns =  $('.accordion-title');
        }
        btns.each(function(){
            var btn =  $(this);
            var targetId = btn.attr('aria-controls');
            btn.click(function(e){
                //normal link
                if(btn.is('a:not(.has-password)')){
                    return;
                }
                //protected
                if(btn.is('a.has-password')){
                    e.preventDefault();
                    var index = btn.attr('data-index');
                    site.openPasswordPop(index);
                    return;
                }

                var isActive = btn.hasClass('active');
                try {
                    site.activateTab(targetId,btn,btns,panels,isActive);
                } catch(e) {

                }

            });
        });
    };
    site.activateTab = function(targetId,btn,btns,panels,isActive) {
        const actionRow = $('#page-action-row');
        var target = $('#'+ targetId);
        if(device.mobile){
            site.closeAllTabs(btns,panels);
            if(isActive){
                return;
            }
            target.addClass('active');
            btn.addClass('active');
        }

        const pos = device.mobile ? btns.first().offset().top : target.offset().top - actionRow.outerHeight();
        scrollToPos(pos);

    };
    site.closeAllTabs = function(btns,panels) {
        btns.removeClass('active');
        panels.removeClass('active');
    };

    site.openPasswordPop = function(index) {
        var pass = prompt('יש להזין סיסמא על מנת לעבור לאתר');
        if(pass != null) {

            $.ajax({
                type   : "POST",
                data   : {id: Show.id, item: index, password: pass},
                url    : site.ajax_url + "?action=menuUrlPassword",
                success: function(r) {
                    if(r.success) {
                        $('a#menu_item_' + index).removeAttr('data-password').attr({
                            'href': r.data.url, target: '_blank'
                        });
                        //window.open(r.data.url);
                        top.location = r.data.url;
                    }
                    else {
                        alert(r.data);
                    }
                },
                error  : function(r) {
                    console.log(r);
                }
            });
        }

    };

    site.initAlertsPopups = function(){
        site.sAlert = function(title, text, icon) {
            Swal.fire({
                icon             : icon,
                title            : title,
                text             : text,
                width:  device.mobile ? '95%' : '450px',
                confirmButtonText: 'אוקיי',
            })
        }

        site.sInfo = function(title, text) {
            site.sAlert(title, text, 'info')
        }

        site.sError = function(title, text) {
            site.sAlert(title, text, 'error')
        }

        site.sSuccess = function(title, text) {
            site.sAlert(title, text, 'success')
        }
    }

    $(document).ready(function() {
        device.mobileileFix();
        site.polyfills();
        site.showsGrid();
        site.print_info_btn();
        site.initContentPanels();
        site.initAlertsPopups();


        $(document).on('click', 'a.disabled', function(e) {
            e.preventDefault();
            return false;
        });

    });//end ready


    $.fn.isOnScreen = function () {

        var win = $(window);

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        };
        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = this.offset();
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

    };
})();



